import React, { useState } from 'react';

function Contact() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [status, setStatus] = useState('');

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('sending');

        try {
            const response = await fetch('/api/contact', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            });

            if (response.ok) {
                setStatus('success');
                setFormData({ name: '', email: '', subject: '', message: '' });
                setTimeout(() => setStatus(''), 5000);
            } else {
                setStatus('error');
            }
        } catch (error) {
            console.error('Error:', error);
            setStatus('error');
        }
    };

    const contactInfo = [
        {
            icon: '📧',
            label: 'Email',
            value: 'bc532@njit.edu',
            href: 'mailto:bc532@njit.edu'
        },
        {
            icon: '📍',
            label: 'Location',
            value: 'New Jersey, USA',
            href: null
        },
        {
            icon: '🎓',
            label: 'School',
            value: 'New Jersey Institute of Technology',
            href: 'https://www.njit.edu'
        }
    ];

    const socialLinks = [
        {
            icon: '💻',
            name: 'GitHub',
            url: 'https://github.com/TheBCann'
        },
        {
            icon: '💼',
            name: 'LinkedIn',
            url: 'https://www.linkedin.com/in/brandon-cannizzaro-3ba8691b9/'
        }
    ];

    return (
        <div className="section">
            <div className="section-header">
                <span className="section-label">Contact</span>
                <h2 className="section-title">Get In Touch</h2>
                <p className="section-description">
                    Have a question or want to work together? I'd love to hear from you!
                </p>
            </div>

            <div className="contact-grid">
                <div className="contact-info">
                    {contactInfo.map((item, index) => (
                        <div key={index} className="contact-card">
                            <div className="contact-icon">{item.icon}</div>
                            <div className="contact-details">
                                <h4>{item.label}</h4>
                                {item.href ? (
                                    <a href={item.href} target="_blank" rel="noopener noreferrer">
                                        {item.value}
                                    </a>
                                ) : (
                                    <p>{item.value}</p>
                                )}
                            </div>
                        </div>
                    ))}

                    <div style={{ marginTop: '1rem' }}>
                        <h4 style={{ 
                            color: 'var(--text-muted)', 
                            fontSize: '0.875rem', 
                            textTransform: 'uppercase',
                            letterSpacing: '0.05em',
                            marginBottom: '1rem'
                        }}>
                            Connect With Me
                        </h4>
                        <div className="social-links">
                            {socialLinks.map((social, index) => (
                                <a 
                                    key={index}
                                    href={social.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="social-link"
                                >
                                    <div className="icon">{social.icon}</div>
                                    <span>{social.name}</span>
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Availability Badge */}
                    <div className="contact-card" style={{ marginTop: '1rem' }}>
                        <div className="contact-icon" style={{ background: 'rgba(39, 201, 63, 0.1)' }}>
                            <span style={{ color: '#27c93f' }}>●</span>
                        </div>
                        <div className="contact-details">
                            <h4>Availability</h4>
                            <p style={{ color: '#27c93f' }}>Open to Opportunities</p>
                        </div>
                    </div>
                </div>

                <div className="contact-form-wrapper">
                    <h3>Send a Message</h3>
                    <form className="contact-form" onSubmit={handleSubmit}>
                        <div className="form-row">
                            <div className="form-group">
                                <label htmlFor="name">Name</label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    placeholder="Your name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    placeholder="your@email.com"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="subject">Subject</label>
                            <input
                                type="text"
                                id="subject"
                                name="subject"
                                placeholder="What's this about?"
                                value={formData.subject}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="message">Message</label>
                            <textarea
                                id="message"
                                name="message"
                                placeholder="Tell me about your project, opportunity, or just say hi!"
                                rows="5"
                                value={formData.message}
                                onChange={handleChange}
                                required
                            ></textarea>
                        </div>

                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={status === 'sending'}
                            style={{ width: '100%' }}
                        >
                            {status === 'sending' ? (
                                <>
                                    <span className="loading-spinner" style={{ 
                                        width: '20px', 
                                        height: '20px',
                                        marginRight: '0.5rem',
                                        borderColor: 'rgba(0,0,0,0.2)',
                                        borderTopColor: 'currentColor'
                                    }}></span>
                                    Sending...
                                </>
                            ) : (
                                'Send Message →'
                            )}
                        </button>

                        {status === 'success' && (
                            <div className="status-message success">
                                <span>✓</span>
                                Message sent successfully! I'll get back to you soon.
                            </div>
                        )}
                        {status === 'error' && (
                            <div className="status-message error">
                                <span>✕</span>
                                Something went wrong. Please try again or email me directly.
                            </div>
                        )}
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Contact;
